var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMicrofonModerator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.439,
    x2: 1,
    y2: 0.481,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77eddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#dbfd95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#defe93"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605",
    transform: "translate(-2512.188 -761.188)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 80.5,
    cy: 80.5,
    r: 80.5,
    transform: "translate(2512.188 761.188)",
    fill: "#0b0425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M29.644-55.144a14.886,14.886,0,0,0-21.038,0l-.624.624L29.02-33.482l.624-.624A14.886,14.886,0,0,0,29.644-55.144ZM4.98-51.518l-.624.624a14.833,14.833,0,0,0-4.3,11.82l13.52,13.52a14.833,14.833,0,0,0,11.82-4.3l.624-.624ZM-3.573-36.7l-1.766,2.032L-32.964-2.789A4.248,4.248,0,0,0-32.752,3l4.25,4.25a4.248,4.248,0,0,0,5.791.213l18.461-16V4.25A4.245,4.245,0,0,0,0,8.5,4.245,4.245,0,0,0,4.25,4.25V-15.911l4.914-4.25L11.2-21.927Z",
    transform: "translate(2593.188 868.188)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrofonModerator);
export default __webpack_public_path__ + "static/media/ic-microfon-moderator.ca7cab83c0ad7cb5fbaae288c4c57ca3.svg";
export { ForwardRef as ReactComponent };